"use client";

import { useFileDetailModal } from "../../FileDetailModal/context/FileDetailModalContext";
import type { ImageFrameRect } from "./useObjectContainImageFrame";

/** True when Analyze is open on the Review tab and the image frame is measured. */
export function useAnalyzeReviewImageOverlay(imageFrame: ImageFrameRect | null) {
  const { isAnalyzeDialogOpen, activeTab } = useFileDetailModal();
  const isActive = isAnalyzeDialogOpen && activeTab === "review" && imageFrame != null;
  return { isActive, imageFrame: isActive ? imageFrame : null };
}
